import { MutableRefObject, useEffect, useRef, useState } from "react";

interface useCarouselReturnData {
  hasNoCompleteButtonPadding: boolean;
  hasNoSubmitButtonPadding: boolean;
  areRightActivitiesHidden: boolean;
  onRightArrowClick: () => void;
  onLeftArrowClick: () => void;
  carouselRef: MutableRefObject<null | HTMLDivElement>;
  activitiesWrapperWidth: string;
}

const LEFT_ARROW_SPACING = 56;

export const useCarousel = (): useCarouselReturnData => {
  const carouselRef = useRef<HTMLDivElement>(null);
  const [hasNoSubmitButtonPadding, setHasNoSubmitButtonPadding] = useState(false);
  const [hasNoCompleteButtonPadding, setHasNoCompleteButtonPadding] = useState(false);

  const [areRightActivitiesHidden, setAreRightActivitiesHidden] = useState(true);
  const [activitiesWrapperWidth, setActivitiesWrapperWidth] = useState("");

  const onLeftArrowClick = (): void => {
    if (carouselRef.current) {
      carouselRef.current.scrollLeft = -(carouselRef.current.scrollWidth - carouselRef.current.clientWidth);
    }
    setAreRightActivitiesHidden(true);
  };

  const onRightArrowClick = (): void => {
    if (carouselRef.current) {
      carouselRef.current.scrollLeft = carouselRef.current.scrollWidth - carouselRef.current.clientWidth;
    }
    setAreRightActivitiesHidden(false);
  };

  useEffect(() => {
    if (carouselRef.current) {
      setActivitiesWrapperWidth(`${(carouselRef.current.clientWidth - LEFT_ARROW_SPACING) / 2}px`);
    }
  }, []);

  useEffect(
    () =>
      carouselRef.current?.offsetWidth && carouselRef.current?.offsetWidth > 786
        ? setHasNoCompleteButtonPadding(false)
        : setHasNoCompleteButtonPadding(true),
    [carouselRef.current?.offsetWidth]
  );

  useEffect(
    () =>
      carouselRef.current?.offsetWidth && carouselRef.current?.offsetWidth > 751
        ? setHasNoSubmitButtonPadding(false)
        : setHasNoSubmitButtonPadding(true),
    [carouselRef.current?.offsetWidth]
  );

  return {
    hasNoSubmitButtonPadding,
    hasNoCompleteButtonPadding,
    areRightActivitiesHidden,
    onRightArrowClick,
    onLeftArrowClick,
    carouselRef,
    activitiesWrapperWidth,
  };
};
